import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import type { SuggestionType } from '@app/api/collaboration';

type GetSuggestionsPayload = {
    baseUrl: string;
    token: string;
    projectIds: Array<string>;
    searchTerm: string;
    keyId: number;
    langId: number;
};

const reviewCenterApi = createApi({
    reducerPath: 'reviewCenter',
    baseQuery: fetchBaseQuery(),
    endpoints: (builder) => ({
        getSuggestions: builder.mutation<SuggestionType[], GetSuggestionsPayload>({
            query: ({ baseUrl, token, ...body }) => ({
                method: 'POST',
                url: `${baseUrl}/users/actions/filter`,
                body,
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }),
            transformResponse: (response: { data: SuggestionType[] }) => response.data,
        }),
    }),
});

export const { useGetSuggestionsMutation } = reviewCenterApi;

export default reviewCenterApi;
